import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './WageInfoScreen';
import WageInfo from './WageInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getWage } from 'src/store/actions/wage-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        wage: state.wages.current,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getWage(id)),
    };
}

const WageInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(WageInfo);

export default WageInfoScreen;
